import {
  adjustmentSessionIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod";

export const editAdjustmentSession = {
  name: "editAdjustmentSession" as const,
  input: z.object({
    sessionId: adjustmentSessionIdFormat.schema,
    items: z.array(
      z.object({
        productId: productIdFormat.schema,
        newQuantity: z.number().int().nonnegative(),
      }),
    ),
    notes: z.string().optional(),
  }),
  output: z.object({ success: z.boolean(), pending: z.boolean().optional() }),
};
